<template>
  <div>
    <div class="msg">
      <Drawer
        v-model="show"
        title="消息中心"
        width="800px"
        :styles="{ padding: 0 }"
        @on-close="drawer_close"
      >
        <div class="message_div">
          <div class="msg_left">
            <div
              @click="click_msg_card(item, i)"
              :class="user_index == i ? 'msg_card_select' : 'msg_card'"
              v-for="(item, i) in user_msg_list"
              :key="i"
            >
              <div class="avatar">
                <img class="avatar_img" :src="item.avatar" alt="" />
              </div>
              <div>
                <div>
                  <Badge :count="item.count" :offset="['+7', '0']">
                    <div class="msg_title">
                      <div>
                        {{ item.name }}
                      </div>
                    </div>
                  </Badge>
                  <div class="msg_detail">
                    {{ item.finally_msg_time_fmt }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="msg_right">
            <div class="msg_header">
              <div class="msg_header_title">
                {{ current_user_item.name }}
              </div>
              <div class="msg_header_detail">
                {{ current_user_item.detail }}
              </div>
            </div>

            <div class="msg_content" id="msg_content">
              <div class="msg_content_inner">
                <div v-for="(msg_info, msg_i) in msg_data_list" :key="msg_i">
                  <div class="msg_time">
                    <span class="msg_time_span">{{ msg_info.send_time }}</span>
                  </div>

                  <div class="msg_content_inner2">
                    <!--左侧头像  -->
                    <div class="msg_content_left msg_time_cur">
                      <div class="msg_user_avatar" v-if="msg_info.status == 'receive'">
                        <img
                          style="width: 100%; height: 100%"
                          :src="msg_user1_info.avatar"
                          alt=""
                        />
                      </div>
                    </div>

                    <!-- 消息内容 -->
                    <div class="msg_card_content">
                      <div
                        :class="
                          msg_info.status == 'receive'
                            ? 'msg_card_content_inner'
                            : 'msg_card_content_inner_right'
                        "
                      >
                        <div
                          :class="
                            msg_info.status == 'receive'
                              ? 'msg_template_card'
                              : 'msg_template_card2'
                          "
                          v-if="msg_info.msg_type == 'template'"
                        >
                          <div class="template_title">
                            {{ msg_info.data.title }}
                          </div>
                          <div>
                            <div
                              v-for="(item, i) in msg_info.data.data"
                              :key="i"
                              class="template_field_div"
                            >
                              <div class="template_field">{{ item.label }}：</div>
                              <div class="template_value">
                                {{ item.value }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          :class="
                            msg_info.status == 'receive'
                              ? 'msg_text_card'
                              : 'msg_text_card2'
                          "
                          v-if="msg_info.msg_type == 'text'"
                        >
                          <div class="">
                            {{ msg_info.data.content }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- 右侧头像 -->
                    <div class="msg_content_right msg_time_cur">
                      <div class="msg_user_avatar" v-if="msg_info.status == 'sender'">
                        <img
                          style="width: 100%; height: 100%"
                          :src="msg_user2_info.avatar"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="send_msg_input_div">
              <Input
                v-model="send_msg_value"
                maxlength="200"
                show-word-limit
                type="textarea"
                placeholder="请输入文本内容..."
                style="width: 100%"
              />
              <div class="send_msg_btn_div">
                <Button
                  :loading="send_msg_loading"
                  @click="send_message()"
                  size="small"
                  style="font-size: 12px"
                  type="primary"
                  ><Icon type="md-paper-plane" /> 发送消息</Button
                >
              </div>
            </div>
          </div>
        </div>
      </Drawer>
    </div>
  </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";

export default {
  name: "message_list",
  data() {
    return {
      show: false,
      user_index: 0,

      msg_user1_info: {
        name: "呵呵",
        avatar:
          "https://img0.baidu.com/it/u=189649806,2789154204&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500",
      },
      msg_user2_info: {
        name: "呵呵2",
        avatar:
          "https://img2.baidu.com/it/u=1790834130,1952230725&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500",
      },

      user_msg_list: [],
      msg_data_list: [
        // {
        //     status: "receive",
        //     msg_type: "template",
        //     send_time: "2020/01/02 10:11",
        //     data: {
        //         title: '未减员通知',
        //         data: [
        //             {
        //                 label: '未减员人数',
        //                 value: "20人"
        //             }
        //         ]
        //     }
        // },
        // {
        //     status: "sender",
        //     msg_type: "template",
        //     send_time: "2020/01/02 10:11",
        //     data: {
        //         title: '未减员通知',
        //         data: [
        //             {
        //                 label: '未减员人数',
        //                 value: "20人"
        //             }
        //         ]
        //     }
        // },
      ],
      current_user_item: {},
      msg_timer_list: [],
      send_msg_value: "",
      send_msg_loading: false,
    };
  },

  mounted() {},

  beforeDestroy() {
    // 在组件销毁前清除定时器
    this.timer.map((item) => {
      clearInterval(item);
    });
    this.msg_timer_list = [];
  },

  methods: {
    send_message() {
        console.log(this.current_user_item)
      if (this.send_msg_value.length == 0) {
        this.$Message.error("请输入内容");
        return;
      }
      var that = this;
      var obj = {
        message_type: "text",
        message_data: {
          content: this.send_msg_value,
          receive_id: this.current_user_item.sender_id,
        },
      };
      that.send_msg_loading = true;
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/message/v1/send_message",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.send_msg_value=''
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.send_msg_loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.send_msg_loading = false;
        });
    },

    //页面关闭
    drawer_close() {
      console.log("页面关闭，停止轮循");

      this.msg_timer_list.map((item) => {
        clearInterval(item);
      });
      this.msg_timer_list = [];
      this.user_index = 0;
    },

    get_message_detail(sender_id, is_scrool) {
      var that = this;
      var obj = {
        sender_id: sender_id,
      };
      http("post", process.env.VUE_APP_MESSAGE_URL + "/message/v1/msg_detail", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.msg_data_list = res.data.data_list;
            that.msg_user1_info = res.data.sender_user_info;
            that.msg_user2_info = res.data.receiver_user_info;
            if (is_scrool === true) {
              console.log("要滚动");
              setTimeout(() => {
                let scroll_to_bottom = document.getElementById("msg_content");
                scroll_to_bottom.scrollTop = scroll_to_bottom.scrollHeight;
              }, 500);
            }
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    get_user_message_list() {
      var that = this;
      var obj = {};
      http("post", process.env.VUE_APP_MESSAGE_URL + "/message/v1/msg_list", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.user_msg_list = res.data.msg_list;
            if (that.user_msg_list.length > 0 && that.user_index == 0) {
              that.current_user_item = that.user_msg_list[0];
              that.get_message_detail(that.current_user_item.sender_id);
            } else {
              console.log("定时刷新详情页");
              that.get_message_detail(that.current_user_item.sender_id);
            }
          } else {
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_msg_card(item, index) {
      console.log(item);
      this.current_user_item = item;
      this.user_index = index;
      this.get_message_detail(item.sender_id, true);
    },

    open() {
      this.show = true;
      var that = this;

      this.msg_timer_list.map((item) => {
        clearInterval(item);
      });
      that.get_user_message_list();
      if (this.msg_timer_list.length == 0) {
        var msg_intervalId = setInterval(() => {
          //获取消息列表
          that.get_user_message_list();
        }, 5000);
        this.msg_timer_list.push(msg_intervalId);
      }
    },
  },
};
</script>

<style scoped>
.demo-badge-alone {
  position: absolute !important;
  top: -2;
}

.msg_time_span {
  padding: 3px 5px;
  background: #f5f5f5;
  border-radius: 3px;
}

.msg_time:hover {
  color: #ababab;
  cursor: pointer;
}

.msg_time:hover .msg_time_span {
  background: #e7e7e7;
}

.msg_time {
  text-align: center;
  font-size: 12px;
  color: #eaeaea;
  margin-bottom: 5px;
}

.template_field_div {
  display: flex;
}

.template_title {
  font-size: 14px;
  margin-bottom: 10px;
}

.template_value {
  font-size: 13px;
}

.template_field {
  width: 80px;
  font-size: 13px;
  flex-shrink: 0;
}

.msg_content_left {
  width: 55px;
  height: 100%;
  flex-shrink: 0;
}

.msg_content_right {
  width: 55px;
  height: 100%;
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
}

.msg_user_avatar {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  overflow: hidden;
  border: 1px solid #f9f8f8;
}

.msg_card_content {
  width: 100%;
}

.msg_card_content_inner {
  max-width: 100%;
  display: flex;
}

.msg_card_content_inner_right {
  max-width: 100%;
  display: flex;
  justify-content: flex-end;
}

.msg_text_card {
  background: #fff;
  padding: 10px 15px;
  border-radius: 5px;
  box-shadow: 0 0 3px #e6e6e6;
  white-space: pre-wrap;
}

.msg_text_card2 {
  background: #2676e8;
  color: #fff;
  padding: 10px 15px;
  border-radius: 5px;
  box-shadow: 0 0 3px #e6e6e6;
  white-space: pre-wrap;
}

.msg_template_card {
  background: #fff;
  padding: 10px 15px;
  border-radius: 5px;
  box-shadow: 0 0 3px #e6e6e6;
}

.msg_template_card2 {
  background: #2676e8;
  padding: 10px 15px;
  color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 3px #e6e6e6;
}

.msg_content_inner {
}

.msg_content_inner2 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.msg_content {
  height: calc(100% - 60px);
  overflow: auto;
  padding: 10px;
}

.user_info_box {
  margin: 10px;
  height: 50px;
  background: #fff;
}

.send_msg_input_div {
  padding-top: 3px;
}

.send_msg_btn_div {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  margin-right: 10px;
}

.msg_right {
  height: calc(100% - 100px);
  background: #f4f4f4;
  width: 100%;
}

.msg_header_detail {
  font-size: 13px;
  color: #ccc;
}

.msg_header_title {
  font-size: 16px;
  color: #000;
  font-family: "DingTalk_JinBuTi";
}

.msg_header {
  height: 60px;
  background: #ffffff;
  width: 100%;
  font-size: 16px;
  color: #000;
  padding: 10px 10px;
  border-bottom: 1px solid #dedede;
}

.msg_title {
  font-family: "DingTalk_JinBuTi";
  font-size: 14px;
  color: #000;
  width: 195px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.msg_detail {
  width: 180px;
  font-size: 12px;
  color: #bababa;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.avatar_img {
  width: 100%;
  height: 100%;
}

.avatar {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background: #0466dd; */
  border: 1px solid #eae4e4;
  border-radius: 5px;
  overflow: hidden;
  margin-right: 10px;
}

.msg_title2 {
  position: relative;
  top: -3px;
}

.msg_card_select {
  height: 60px;
  padding: 10px;
  background: #ededed;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f1f1f1;
  cursor: pointer;
}

.msg_card {
  cursor: pointer;
  height: 60px;
  padding: 10px 10px 10px 10px;
  background: #ffffff;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f1f1f1;
}

.msg_card:hover {
  cursor: pointer;
  background: #f5f5f5;
}

:deep(.ivu-modal-header) {
  padding: 0;
}

.message_div {
  height: calc(100vh - 52px);
  overflow: auto;
  display: flex;
}

.msg_left {
  width: 280px;
  flex-shrink: 0;
  height: 100%;
  overflow: auto;
  background: #f4f4f4;
  border-right: 1px solid #ccc;
}

.header {
  height: 25px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
}
</style>
